import type {
  MubinsoBinsoRow,
  MubinsoFeeRow,
} from "@/utils/buildMubinsoPageProps";

interface MubinsoFeesProps {
  companyName: string;
  feeRows: MubinsoFeeRow[];
  binsoRows: MubinsoBinsoRow[];
  title?: string;
}

/**
 * 이 장례식장의 항목별 요금. 무빈소 총액이 어디서 나왔는지 보여주는 근거다.
 *
 * 빈소 사용료는 무빈소에서는 들지 않지만 함께 보여준다. 가족장과 비교하려는 사람이
 * 가장 먼저 찾는 값이고, 장례식장마다 다른 정보라 페이지끼리 겹치지 않는다.
 */
export const MubinsoFees = ({
  companyName,
  feeRows,
  binsoRows,
  title,
}: MubinsoFeesProps) => {
  if (!feeRows.length && !binsoRows.length) return null;

  return (
    <section className="mb-about" aria-labelledby="mb-fees-title">
      <h2 id="mb-fees-title" className="mb-about__title">
        {title ?? `${companyName} 항목별 요금`}
      </h2>

      {feeRows.length > 0 && (
        <div className="mb-about__table-wrap">
          <table className="mb-compare">
            <caption className="mb-compare__caption">
              무빈소에도 드는 시설 이용료
            </caption>
            <tbody>
              {feeRows.map((row) => (
                <tr key={row.label}>
                  <th scope="row">{row.label}</th>
                  <td>{row.chargeLabel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {binsoRows.length > 0 && (
        <div className="mb-about__table-wrap">
          <table className="mb-compare">
            <caption className="mb-compare__caption">
              {`빈소 사용료 (총 ${binsoRows.length}실, 무빈소는 들지 않음)`}
            </caption>
            <thead>
              <tr>
                <th scope="col">빈소</th>
                <th scope="col">평형</th>
                <th scope="col">1일 사용료</th>
              </tr>
            </thead>
            <tbody>
              {binsoRows.map((row, index) => (
                <tr key={`${row.name}-${index}`}>
                  <th scope="row">{row.name}</th>
                  <td>{row.pyeongLabel}</td>
                  <td>{row.chargeLabel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p className="mb-about__note">
        * e하늘 장사정보시스템 공개 가격 기준이며, 실제 요금은 장례식장에 확인해
        주세요.
      </p>
    </section>
  );
};
